import PageMeta from "@/components/base/PageMeta";
import Breadcrumb from "@/components/base/Breadcrumb";
import FeedbackForm from "@/pages/about/components/FeedbackForm";

const positioning = [
  {
    icon: "ri-movie-2-line",
    title: "围绕一部剧的内容档案",
    text: "本站聚焦电视剧《年轻的母亲1》，把分散的剧集信息、演员资料与剧情讨论整理成清晰的内容档案，方便剧迷随时查阅。",
  },
  {
    icon: "ri-compass-3-line",
    title: "为追剧用户服务",
    text: "目标用户是中文影视剧爱好者，尤其是关注剧情深度内容与相关资料的用户。我们希望降低查找成本，让信息一步到位。",
  },
  {
    icon: "ri-shield-check-line",
    title: "明确的功能边界",
    text: "站内的播放区块与表单均为界面演示，数据为静态演示内容，不代表真实播放或真实后台收集。",
  },
];

const notices = [
  "本站为非官方粉丝向内容展示站点，所有剧集信息与资料仅供学习交流。",
  "站内播放区域仅展示剧集图片与信息，播放按钮为界面演示，不支持真实在线播放。",
  "收藏功能使用浏览器本地存储保存，仅在你的设备上生效，清除浏览器数据后收藏会重置。",
  "反馈表单用于收集内容纠错与建议，提交后我们会在后台查看，不提供即时回复。",
  "如内容涉及版权问题，欢迎通过反馈表单联系我们，我们会及时处理。",
];

export default function About() {
  return (
    <>
      <PageMeta
        title="关于我们 - 年轻的母亲1官网"
        description="了解年轻的母亲1内容档案站的定位、目标用户与使用须知，并通过反馈表单与我们联系。"
        keywords="年轻的母亲1官网,关于年轻的母亲1,年轻的母亲1内容站"
      />

      <div className="border-b border-background-200 bg-background-100">
        <div className="mx-auto max-w-site px-4 py-8 md:px-6 md:py-10">
          <Breadcrumb items={[{ label: "关于" }]} />
          <h1 className="mt-4 text-2xl font-bold text-foreground-950 md:text-3xl">关于我们</h1>
          <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600">
            年轻的母亲1 内容档案站，致力于把《年轻的母亲1》的剧集、演员与剧情解析整理得清楚、好读、好找。
          </p>
        </div>
      </div>

      <div className="mx-auto max-w-site px-4 py-10 md:px-6 md:py-14">
        <section className="grid grid-cols-1 gap-5 md:grid-cols-3">
          {positioning.map((item) => (
            <div key={item.title} className="rounded-lg border border-background-200 bg-background-50 p-6">
              <span className="flex h-12 w-12 items-center justify-center rounded-md bg-primary-100 text-xl text-primary-600">
                <i className={item.icon} />
              </span>
              <h2 className="mt-4 text-base font-semibold text-foreground-950">{item.title}</h2>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.text}</p>
            </div>
          ))}
        </section>

        <div className="mt-12 grid grid-cols-1 gap-10 lg:grid-cols-[minmax(0,1fr)_420px]">
          <section>
            <h2 className="flex items-center gap-2 text-lg font-semibold text-foreground-950">
              <span className="h-4 w-1 rounded-full bg-accent-500" />
              使用须知
            </h2>
            <ul className="mt-4 space-y-3">
              {notices.map((notice, index) => (
                <li
                  key={index}
                  className="flex items-start gap-3 rounded-lg border border-background-200 bg-background-50 p-4 text-sm leading-relaxed text-foreground-700"
                >
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-[11px] font-semibold text-secondary-900">
                    {index + 1}
                  </span>
                  <span>{notice}</span>
                </li>
              ))}
            </ul>
          </section>

          <section>
            <h2 className="flex items-center gap-2 text-lg font-semibold text-foreground-950">
              <span className="h-4 w-1 rounded-full bg-accent-500" />
              意见反馈
            </h2>
            <p className="mb-4 mt-2 text-sm text-foreground-600">
              如果你发现内容有误，或想提出建议，欢迎通过下面的表单告诉我们。
            </p>
            <FeedbackForm />
          </section>
        </div>
      </div>
    </>
  );
}